import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
// import {KInputTextDirective} from './directive/kinput-text/kinput-text.directive';

@NgModule({
	declarations: [
		// KInputTextDirective
	],
	imports: [
		CommonModule
	]
})
export class KInputModule {
}
